import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessage } from '../../../util/reactIntl';
import { NamedLink } from '../../../components';
import whiteLogo from '../images/whiteLogo.png';
import couchTexture from '../images/Home-1.png';

import css from './SectionAnimation.module.css';

const SectionAnimation = props => {
    const { rootClassName, className } = props;

    const classes = classNames(rootClassName || css.root, className);
    return (
        <div className={classes}>
            <img src={couchTexture} className={css.animationCouchTexture} />

            <div className={css.container}>
                <div className={css.dummyHeroLeft} />
                <div className={css.dummyHeroRight}>
                    <div className={css.dummyHeroRightImageWrapper}>
                        <div className={css.dummyGatePic} />
                        <img src={whiteLogo} className={css.animationWhiteLogo} />
                    </div>
                </div>
            </div>
        </div>
    );
};

SectionAnimation.defaultProps = {
    rootClassName: null,
    className: null
};

const { string } = PropTypes;

SectionAnimation.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionAnimation;